import React, { useEffect, useState } from 'react';
import DataTable from '@salesforce/design-system-react/module/components/data-table';
import DataTableColumn from '@salesforce/design-system-react/module/components/data-table/column';
import DataTableCell from '@salesforce/design-system-react/module/components/data-table/cell';
import { useDispatch, useSelector } from 'react-redux';
import { getSuperAdmin, superAdminSelector } from '../../../store/superAdmin/slice';
import { authSelector } from '../../../store/auth/slice';
import moment from 'moment';

const CustomDataNameTableCell = ({ children, ...props }) => {
  const { item } = props;
  return (
    <DataTableCell title={children} {...props}>
      <div style={{ height: '30px', display: 'flex', alignItems: 'center' }}>
        {`${item?.first_name ? item?.first_name : ' '} ${item?.last_name ? item?.last_name : ' '}`}
      </div>
    </DataTableCell>
  );
};

CustomDataNameTableCell.displayName = DataTableCell.displayName;

const CustomDataTableDate = ({ children, ...props }) => {
  const { item } = props;

  return (
    <DataTableCell title={children} {...props}>
      {moment(item.updatedAt).format('MM/D/yyyy HH:mm:ss')}
    </DataTableCell>
  );
};
CustomDataTableDate.displayName = DataTableCell.displayName;

const UserTable = ({ setData }) => {
  const dispatch = useDispatch();
  const { superAdmin, loading, pagination } = useSelector(superAdminSelector);
  const { user } = useSelector(authSelector);
  const [sortColumn, setSortColumn] = useState('');
  const [sortColumnDirection, setSortColumnDirection] = useState('');
  const [items, setItems] = useState([]);
  // const [isLoading, setIsLoading] = useState(true);
  // const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [paginated, setPaginated] = useState(0);
  // const [searchText, setSearchText] = useState('');

  useEffect(() => {
    if (user?.role === 'super_admin') {
      dispatch(getSuperAdmin())
    }
  }, [dispatch]);

  useEffect(() => {
    if (superAdmin.length > 0) {
      setItems(superAdmin);
      setData(superAdmin);
    }
  }, [superAdmin]);

  // useEffect(() => {
  //   setIsLoading(loading);
  // }, [loading]);

  const handleSort = (sortColumn, ...rest) => {
    const { property, sortDirection } = sortColumn;
    setSortColumn(property);
    setSortColumnDirection(sortDirection);
    setItems([]);
    setHasMore(true);
    setIsPageLoading(false);
    setPaginated(0);
    dispatch(getSuperAdmin({ sort_column: property, sort_order: sortDirection }));


    // sorting will actually be handled from api
    // so dispatch sort action in useEffect
    // dispatch(sortAccounte({sortDirection, sortProperty}))
    // and the update the state with sorted accounts lists this will be done by above useEffect
  };

  const handleLoadMore = () => {
    if (!loading && !isPageLoading) {
      setIsPageLoading(true);
      setTimeout(() => {
        if (pagination?.pages <= 1 || paginated >= pagination?.pages) {
          setHasMore(false);
          setIsPageLoading(false);
          return;
        }

        if (pagination.currentPage >= pagination.pages) {
          setHasMore(false);
          setIsPageLoading(false);
          return;
        }
        let url = new URLSearchParams(pagination.nextPageUrl);
        setPaginated(paginated + 1);
        let requestParams = {
          limit: url.get('limit'),
          offset: url.get('offset'),
        }
        if(!!sortColumn && !!sortColumnDirection){
          requestParams['sort_column'] = sortColumn;
          requestParams['sort_order'] = sortColumnDirection;
        }
        dispatch(
          getSuperAdmin(requestParams)
        );
        setIsPageLoading(false);
      }, 1000);
    }
  };

  return (
    <div className="table-container">
      {/* <div className="slds-text-heading_medium table-header">All Users</div>
      <div style={{ marginBottom: '20px' }}>
        On this page you can create, view, and manage users.
      </div> */}

      <div
        style={{
          height: `${superAdmin.length === 0 ? '100%' : 'calc(100vh - 240px)'}`
        }}
      >
        <DataTable
          assistiveText={{
            actionsHeader: 'actions',
            columnSort: 'sort this column',
            columnSortedAscending: 'asc',
            columnSortedDescending: 'desc',
            selectAllRows: 'Select all rows',
            selectRow: 'Select this row',
          }}
          fixedHeader
          fixedLayout
          items={items}
          id="DataTableExample-FixedHeaders"
          onSort={handleSort}
          hasMore={hasMore}
          onLoadMore={handleLoadMore}
          noRowHover
        >
          <DataTableColumn
            isSorted={sortColumn === 'first_name'}
            label="Name"
            property="first_name"
            primaryColumn
            sortable
            sortDirection={sortColumnDirection.first_name}
            width="13rem"
          >
            <CustomDataNameTableCell />
          </DataTableColumn>

          <DataTableColumn sortable isDefaultSortDescending label="Username" property="email" />
          <DataTableColumn
            isSorted={sortColumn === 'contact_number'}
            label="Phone"
            property="contact_number"
            sortable
            sortDirection={sortColumnDirection.contact_number}
          />
          <DataTableColumn
            isSorted={sortColumn === 'email'}
            label="Email"
            property="email"
            sortable
            sortDirection={sortColumnDirection.email}
          />
          <DataTableColumn label="Role" property="role" width="8rem" />

          <DataTableColumn
            isSorted={sortColumn === 'updatedAt'}
            label="Date Added"
            property="updatedAt"
            sortable
            sortDirection={sortColumnDirection.updatedAt}
          >
            <CustomDataTableDate />
          </DataTableColumn>
        </DataTable>
      </div>
    </div>
  );
};

export default UserTable;
